import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";

const IconCircuit = ({ size, ...props }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...size !== undefined && { width: size, height: size }}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18 1.25C15.3696 1.25 13.25 3.40183 13.25 6.04035C13.25 7.50263 13.9236 8.57844 14.6959 9.4597C15.034 9.84551 15.4072 10.2116 15.7574 10.5552L15.8877 10.6832C16.2841 11.0731 16.6474 11.4392 16.958 11.8249C17.4807 12.4742 18.5059 12.4976 19.0494 11.8468C19.3701 11.4627 19.7392 11.0935 20.1381 10.6975L20.182 10.6539C20.5596 10.2791 20.9632 9.87858 21.327 9.45289C22.09 8.55999 22.75 7.47512 22.75 6.04035C22.75 3.40183 20.6304 1.25 18 1.25ZM18 4.25C17.0335 4.25 16.25 5.0335 16.25 6C16.25 6.9665 17.0335 7.75 18 7.75H18.009C18.9755 7.75 19.759 6.9665 19.759 6C19.759 5.0335 18.9755 4.25 18.009 4.25H18Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.25 19C1.25 16.9289 2.92893 15.25 5 15.25C7.07107 15.25 8.75 16.9289 8.75 19C8.75 21.0711 7.07107 22.75 5 22.75C2.92893 22.75 1.25 21.0711 1.25 19Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 10C5 7.65179 7.16489 6 9.5 6H11C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8H9.5C7.96911 8 7 9.0345 7 10C7 10.9655 7.96911 12 9.5 12H12.5C14.8351 12 17 13.6518 17 16C17 18.3482 14.8351 20 12.5 20H11C10.4477 20 10 19.5523 10 19C10 18.4477 10.4477 18 11 18H12.5C14.0309 18 15 16.9655 15 16C15 15.0345 14.0309 14 12.5 14H9.5C7.16489 14 5 12.3482 5 10Z"
			fill="currentColor"
		/>
	</svg>
);

IconCircuit.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IconCircuit;
